module.exports = __webpack_public_path__ + "static/img/cr.a7d3b312.svg";